/**
 * Infrastructure Layer - Camera Adapter Factory
 * 
 * Factory para crear la implementación correcta del escáner de cámara
 * según la plataforma (nativo o web).
 */

import {Platform} from 'react-native';
import {ICameraScanner} from '../../domain/camera/interfaces/ICameraScanner';
import {NativeCameraAdapter} from './adapters/NativeCameraAdapter';
import {WebCameraAdapter} from './adapters/WebCameraAdapter';

export class CameraAdapterFactory {
  private static instance: ICameraScanner | null = null;

  /**
   * Crea o retorna la instancia del adaptador de cámara apropiado
   * según la plataforma actual.
   */
  static getInstance(): ICameraScanner {
    if (!this.instance) {
      this.instance = this.create();
    }
    return this.instance;
  }

  /**
   * Crea una nueva instancia del adaptador apropiado
   */
  static create(): ICameraScanner {
    if (Platform.OS === 'web') {
      console.log('Usando WebCameraAdapter para plataforma web');
      return new WebCameraAdapter();
    }
    
    console.log('Usando NativeCameraAdapter para plataforma nativa');
    return new NativeCameraAdapter();
  }

  /**
   * Resetea la instancia (útil para testing)
   */
  static reset(): void {
    this.instance = null;
  }
}
